import React, { useState, useCallback, useEffect, useRef } from 'react';

import { Table, Spin, Button, Input, Space, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { I18n as I } from 'react-redux-i18n';

import { formatDecimal, PartyTypes, downloadCSVFile } from 'vdlib';

import LookupsHelper from 'lib/LookupsHelper';

import { getColumns } from './columns';
import compose from 'ramda/src/compose';
import {
  withTextFilter,
  withEnumFiltersCheckboxContent,
} from '../../lib/columnExtentions';

const { Paragraph, Text } = Typography;

const MerchantFees = ({
  fetchData,
  updateFees,
  clearData,
  updateMerchantsFeesData,
  fees,
  partyTypes,
  user,
  loading,
}) => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    fetchData();

    setIsAdmin(
      LookupsHelper.getDescription(partyTypes, user.PartyType) ===
        PartyTypes.Operator
    );

    return () => {
      clearData();
    };
  }, [updateMerchantsFeesData]);

  const columnsWidth = React.useMemo(
    () =>
      (getColumns(isAdmin) || []).reduce(
        (sum, columnDef) =>
          sum + (typeof columnDef.width === 'number' ? columnDef.width : 0),
        800
      ),
    [getColumns(isAdmin)]
  );

  const descriptionMapper = key => {
    switch (key) {
      case 'Merchant':
        return 'Έμπορος';
      case 'AuctionID':
        return 'Δημοπρασίας';
      case 'Amount':
        return 'Χρέωση';
      case 'IsPaid':
        return 'Πληρωμή';
      case 'PaymentDate':
        return 'Ημερ.Πληρωμής';
      case 'FolderNumber':
        return 'Αρ.Φακέλου';
      case 'VehicleBrand':
        return 'Μαρκα';
      case 'VehicleModel':
        return 'Μοντέλο';
      case 'PlateNumber':
        return 'Αρ.Κυκλοφορίας';
      case 'EndDate':
        return 'Ημερ.Δημοπρασίας';
      default:
        return key;
    }
  };

  const valueTransformation = data => {
    let keysToFormat = ['Amount'];

    if (data.IsPaid) {
      data.IsPaid = 'Πληρώθηκε';
    } else {
      data.IsPaid = 'Δεν Πληρώθηκε';
    }

    data.RespId = keysToFormat.forEach(k => {
      if (data[k]) data[k] = formatDecimal(data[k]);
    });
  };

  // const getColumnSearchProps = dataIndex => ({
  //   filterDropdown: ({
  //     setSelectedKeys,
  //     selectedKeys,
  //     confirm,
  //     clearFilters,
  //   }) => (
  //     <div style={{ padding: 8 }}>
  //       <Input
  //         placeholder={`Search ${dataIndex}`}
  //         value={selectedKeys[0]}
  //         onChange={e =>
  //           setSelectedKeys(e.target.value ? [e.target.value] : [])
  //         }
  //         onPressEnter={() => {
  //           confirm();
  //         }}
  //         onBlur={() => {
  //           confirm();
  //         }}
  //         style={{ width: 188, marginBottom: 8, display: 'block' }}
  //       />
  //       <Space>
  //         <Button
  //           type="primary"
  //           onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
  //           icon={<SearchOutlined />}
  //           size="small"
  //           style={{ width: 90 }}
  //         >
  //           Search
  //         </Button>
  //         <Button
  //           onClick={() => handleReset(clearFilters)}
  //           size="small"
  //           style={{ width: 90 }}
  //         >
  //           Reset
  //         </Button>
  //       </Space>
  //     </div>
  //   ),
  //   filterIcon: filtered => (
  //     <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  //   ),
  //   onFilter: (value, record) =>
  //     record[dataIndex]
  //       ? record[dataIndex]
  //           .toString()
  //           .toLowerCase()
  //           .includes(value.toLowerCase())
  //       : '',
  // });

  // const handleSearch = (selectedKeys, confirm, dataIndex) => {
  //   confirm();
  // };

  // const handleReset = clearFilters => {
  //   clearFilters();
  // };

  return (
    <div>
      <h1 className="page-title">
        {isAdmin ? I.t('MERCHANT_FEES') : I.t('FEES')}
      </h1>
      <Spin spinning={loading}>
        <Table
          bordered
          dataSource={
            fees?.sort(function (a, b) {
              return a.IsPaid - b.IsPaid;
            }) || []
          }
          // columns={compose(
          //   withEnumFiltersCheckboxContent(checkFilters, fees),
          //   withTextFilter(textFilters)
          // )(getColumns({ getColumnSearchProps, isAdmin, updateFees }))} //{ getColumnSearchProps },

          columns={fees ? getColumns(isAdmin, updateFees) : null}
          scroll={{ x: columnsWidth }}
        />
        <Button
          onClick={() =>
            downloadCSVFile(
              fees || [],
              'fees.csv',
              ['ID', 'MerchantID'],
              valueTransformation,
              descriptionMapper
            )
          }
          style={{ marginTop: 20 }}
          type="primary"
        >
          Export
        </Button>
      </Spin>
    </div>
  );
};

export default MerchantFees;
